import { Customer } from "../customer/customer-model";

export class BulkChangeOrderStatus {
  public orderIds: number[];
  public orderStatus: number;
}


export class Order { 
  public id: string;
  public orderID: number;
  public orderBy: number;
  public StrOrderBy: string
  public orderDate: Date;
  public orderStatus: number;
  public orderStatusDisplay: string;
  public total: number;
  public taxtTotal: number;
  public subTotal: number;
  public city: string;
  public stateID: number;
  public countryID: number;
  public couponID: number;
  public trackingNumber: string;
  public trackingNumbers: any[]=[];
  public paymentType: number;
  public shippingPrice: number;
  public shipCarrierID: number;
  public currancyCode: string;
  public languageID: string;
  public shippingAddress: string;
  public shippingCity: string;
  public shippingCountryID: number;
  public shippingStateID: number;
  public shippingZipCode: string;
  public billingAddress: string;
  public billingCity: string;
  public billingCountryID: string;
  public billingStateID: string;
  public billingZipCode: string;
  public couponAmount: number;
  public paymentSaleID: number;
  public paymentSaleAmount: number;
  public customerName: string;
  public customerPhone: string;
  public totalRecords: number;
  public checked: boolean = false;
  public vendors: Customer[] = [];
}


export class BlueEXResponse {
        public status: string;
        public success: string;
        public order_refernce_code: string;
        public message: string;
        public cn: string;
        public error_message: string;
        public result: string;
        public order_code: string;
    }




// WEBPACK FOOTER //
// ./src/app/models/order/order.model.ts